var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastTimeDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5.33333V8.66667L10.1667 10.3467L10.68 9.49333L8.33333 8.1V5.33333H7.33333ZM14 6.66667V2L12.24 3.76C11.16 2.67333 9.66 2 8 2C4.68667 2 2 4.68667 2 8C2 11.3133 4.68667 14 8 14C11.3133 14 14 11.3133 14 8H12.6667C12.6667 10.5733 10.5733 12.6667 8 12.6667C5.42667 12.6667 3.33333 10.5733 3.33333 8C3.33333 5.42667 5.42667 3.33333 8 3.33333C9.28667 3.33333 10.4533 3.86 11.3 4.7L9.33333 6.66667H14Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastTimeDownloadIcon);
export default __webpack_public_path__ + "static/media/LastTimeDownloadIcon.9fdfeec0.svg";
export { ForwardRef as ReactComponent };